/** The facilitator's "nothing to show yet" state: the shared status card, one sentence and (when there is one) the next step. */
import type { ReactNode } from "react";
import type { IconName } from "../theme/icons";
import { GxStatusCard } from "../theme/GxStatusCard";

export function EmptyState({ icon, title, children, action, testId }: { readonly icon: IconName; readonly title: string; readonly children?: ReactNode; readonly action?: ReactNode; readonly testId?: string }) {
  return (
    <div className="gx-fac-empty">
      <GxStatusCard icon={icon} title={title} detail={undefined} {...(action === undefined ? {} : { action })} {...(testId === undefined ? {} : { testId })}>{children}</GxStatusCard>
    </div>
  );
}
